import React from 'react';
import { LegalEtherealBackdrop } from './ui/ethereal-shadow';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <LegalEtherealBackdrop />
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="privacy-content">
          <section className="policy-section">
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you:</p>
            <ul>
              <li>Fill out contact forms or project inquiries</li>
              <li>Subscribe to our newsletter</li>
              <li>Request a quote or consultation</li>
              <li>Engage with our services</li>
            </ul>
            <p>This information may include your name, email address, phone number, company information, and project details.</p>
          </section>

          <section className="policy-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Communicate with you about projects and services</li>
              <li>Send you marketing materials (with your consent)</li>
              <li>Respond to your inquiries and support requests</li>
              <li>Analyze website usage and improve user experience</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:</p>
            <ul>
              <li>To trusted service providers who assist us in operating our website and conducting business</li>
              <li>When required by law or to protect our rights and safety</li>
              <li>In connection with a business transfer or merger</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>4. Cookies and Tracking</h2>
            <p>We use cookies and similar tracking technologies to:</p>
            <ul>
              <li>Remember your preferences and settings</li>
              <li>Analyze website traffic and usage patterns</li>
              <li>Provide personalized content and advertisements</li>
              <li>Improve website functionality and performance</li>
            </ul>
            <p>You can control cookie settings through your browser preferences.</p>
          </section>

          <section className="policy-section">
            <h2>5. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
          </section>

          <section className="policy-section">
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and review your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>7. Children's Privacy</h2>
            <p>Our services are not intended for children under 18 years of age. We do not knowingly collect personal information from children under 18.</p>
          </section>

          <section className="policy-section">
            <h2>8. Changes to This Policy</h2>
            <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.</p>
          </section>

          <section className="policy-section">
            <h2>9. Contact Us</h2>
            <p>If you have any questions about this privacy policy or our data practices, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> guevaramauricio754@gmail.com</p>
              <p><strong>Phone:</strong> +1 (336) 569-9022</p>
              <p><strong>Address:</strong> Winston-Salem, NC</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 